import history from "router/history";

export const SuccessResponseInterceptor = _ => {
    if (_.status === 200) {
        return Promise.resolve({
            data: _.data,
            error: null
        });
    } else {
        return Promise.resolve({
            data: _,
            error: null
        });
    }
};
export const ErrorResponseInterceptor = _ => {
    if(_.response.status === 403) {
        localStorage.removeItem("Authorization");
        localStorage.removeItem("RefreshToken");
        history.replace("/auth");
        return;
        
    }
    return Promise.reject(_);
};
